import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from '../../../lib'
import { Response } from '../../../services/api/types'
import { User } from '../types'

const loadUser = (id?: string): Response<User> => {
  return axios.get(`/users/${id}`)
}

export function useLoadUser(id?: string) {
  return useQuery(['users', id], () => loadUser(id), {
    enabled: !!id,
    select: (data) => data.data,
    onError: () =>
      toast.error('Não foi possível carregar o usuário', {
        toastId: 'user'
      })
  })
}
